import React from 'react';
import './AwardsContent.css';
import Container from '@material-ui/core/Container';
// import Awardstab from './Awardstab';
import Awards from '../sap-pages/Awards';

function AwardsContent() {
  return (
    <>
        <div className="main-container">
            <title>LKM Portal - Awards</title>
            <img src="/images/awards/bannerawards.png" alt="banner" className='banner-img'/>
        </div>
        <div className="banner-bar"></div>
        <Container className='awards-container' maxWidth="xl">
           <div className="awards-wrap">
            {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Suscipit provident vitae at unde.
               Ipsam error dolor rerum officia,
               cum totam! Alias at reiciendis praesentium, neque consectetur quo ipsam ab dignissimos.</p> */}
                 </div>
           <Awards />
        </Container>
    </>
  )
}

export default AwardsContent;